import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import I18n from 'apps/new-web/views/components/i18n';
import PreWorkoutStats from '../pre-workout-stats';
import PostWorkoutStats from '../post-workout-stats';

const MobileHero = ({ unitSystem, mediaType, sharedWorkout: { user, workout } }) => {
  return (
    <div className="mobile-hero-section">
      <div className="scrim" />
      <div
        className="background-image"
        style={ workout.imageUrls && {
          backgroundImage: `url(${ workout.imageUrls.largeImage })`
        } }
      />
      <div className="copy-container">
        <h1>{ workout.title}</h1>
        { user &&
          <p><I18n desc="Title describing who completed the workout.">Completed by</I18n> { user.fullname }</p>
        }
        { user
          ? <PostWorkoutStats mediaType={ mediaType } unitSystem={ unitSystem } />
          : <PreWorkoutStats mediaType={ mediaType } unitSystem={ unitSystem } />
        }
      </div>
    </div>
  );
};

MobileHero.propTypes = {
  mediaType: PropTypes.string.isRequired,
  sharedWorkout: PropTypes.object.isRequired,
  unitSystem: PropTypes.string.isRequired
};

const ConnectedMobileHero = connect((state) => {
  return {
    sharedWorkout: state.sharedWorkout,
    unitSystem: state.user ? state.user.personal.unitSystem : 'standard'
  };
})(MobileHero);

export default ConnectedMobileHero;